import { replacePathParams } from '@/api/utils';

export const filesApiPaths = {
  caseFileAttach: '/caseservice/cases/:caseId/attach-files',
  caseFileRemove: '/caseservice/cases/:caseId/files/:fileId',
  caseFileSignedUrl: '/caseservice/cases/files/signed-url',
  caseReallocationFilesTransfer: '/caseservice/cases/:caseId/files/copy-reallocation',
  // opos, hospitals, txCenters, providers
  facilityFileSignedUrl: '/facilityservice/logos/files/signed-url',
  customerFileSignedUrl: '/customerservice/logos/files/signed-url',
  // ocs consoles, employees
  resourceFileSignedUrl: '/resourceservice/logos/files/signed-url',
  opoFileSignedUrl: '/oposervice/photos/files/signed-url',
  opoContactPhotoFileSignedUrl: '/opobff/opo-platform/photos/files/signed-url',
  offerFileSignedUrl: '/offerservice/offers/files/signed-url',
} as const;

export const getFilesApiUrl = {
  fileSignedUrl: () => filesApiPaths.caseFileSignedUrl,
  fileAttach: (caseId: string) => replacePathParams(filesApiPaths.caseFileAttach, { caseId }),
  fileRemove: (caseId: string, fileId: string) => replacePathParams(filesApiPaths.caseFileRemove, { caseId, fileId }),
  reallocationFilesTransfer: (caseId: string) =>
    replacePathParams(filesApiPaths.caseReallocationFilesTransfer, { caseId }),
  facilityFileSignedUrl: () => filesApiPaths.facilityFileSignedUrl,
  customerFileSignedUrl: () => filesApiPaths.customerFileSignedUrl,
  resourceFileSignedUrl: () => filesApiPaths.resourceFileSignedUrl,
  opoFileSignedUrl: () => filesApiPaths.opoFileSignedUrl,
  opoContactPhotoFileSignedUrl: () => filesApiPaths.opoContactPhotoFileSignedUrl,
  offerFileSignedUrl: () => filesApiPaths.offerFileSignedUrl,
};
